// Modules
import React, { useState } from 'react'
import { Search, Typography } from '@dasa-health/components-react'
import { SystemBoldRoundcheckon } from '@dasa-health/icons'

// Application
import { Lab } from 'typings/auth'

// Components
import { StyledForm, LabList, LabItem, LabTitle } from './style'

interface Props {
    handleSubmit: (lab: Lab) => void
    isSubmitting: boolean
    options: Lab[]
}

type Event = React.ChangeEvent<HTMLInputElement>

export const SelectLaboratoryForm: React.VFC<Props> = ({ handleSubmit, options }) => {
    const [filter, setFilter] = useState<string>('')
    const [selected, setSelected] = useState<number>()

    const filtering = (option: Lab) => {
        if (!filter) {
            return true
        }
        const strNormalized = option.title
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
        const filterNormalized = filter
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return strNormalized.includes(filterNormalized)
    }

    const handleClick = (item: Lab, index: number) => {
        setSelected(index)
        handleSubmit(item)
    }

    return (
        <StyledForm>
            <Typography as="h1" mb={16} size={4} sx={{ fontWeight: '700' }}>
                Qual laboratório procura?
            </Typography>

            <Typography as="h2" mb={2} size={1} weight={400}>
                Escolha o laboratório onde estão os resultados de exames que deseja ver.
            </Typography>
            <div className="form__login">
                <Search
                    className="form__login__field"
                    data-testid="lab-input"
                    name="lab"
                    onChange={(e: Event) => setFilter(e.target.value)}
                    placeholder="Busca por Laboratórios"
                    value={filter}
                />
                <LabList>
                    {options.filter(filtering).map((item, index) => (
                        <LabItem className={selected === index ? 'active' : ''} key={index} onClick={() => handleClick(item, index)}>
                            <LabTitle>{item.title}</LabTitle>
                            {selected === index && (
                                <span className="icon">
                                    <SystemBoldRoundcheckon height={20} width={20} />
                                </span>
                            )}
                        </LabItem>
                    ))}
                </LabList>
            </div>
        </StyledForm>
    )
}
